import { useCallback, useEffect, useState } from 'react';

import { useFeedbackStore } from '../../../modules/feedback/hooks/useFeedbackStore';
import { useGetPrivacyVersion } from '../../hooks/useGetPrivacyVersion';
import { useTimerStore } from '../../hooks/useTimerStore';
import { VersionStructure } from '../../types';
import { CookieBanner } from './CookieBanner/CookieBanner';
import styles from './Header.module.css';

const Header = () => {
    const showTimer = useTimerStore((s) => s.isVisible);
    const timer = useTimerStore((s) => s.time);
    const showPageNumber = useFeedbackStore((s) => s.isPageNumberVisible);
    const page = useFeedbackStore((s) => s.pageNumber);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const [showCookiesBanner, setShowCookiesBanner] = useState(false);
    const defaultVersion: VersionStructure = {
        Offert: '0000-00-00',
        PP: '0000-00-00',
        ToU: '0000-00-00',
    };
    const [versions, setVersions] = useState<VersionStructure>(defaultVersion);
    const { data: privacyVersionData } = useGetPrivacyVersion();
    const handleClick = () => {
        setIsPopoverOpen((prev) => !prev);
    };
    const handleClose = useCallback(() => {
        setIsPopoverOpen(false);
    }, []);
    const onSubmitCookie = () => {
        const jsonData = JSON.stringify(versions);
        document.cookie = `cookieBanner=${jsonData}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
        setShowCookiesBanner(false);
    };
    useEffect(() => {
        if (!privacyVersionData) return;

        setVersions(privacyVersionData);
        const cookieBanner = document.cookie.replace(
            /(?:(?:^|.*;\s*)cookieBanner\s*=\s*([^;]*).*$)|^.*$/,
            '$1',
        );
        let shouldShowBanner = true;
        if (cookieBanner) {
            const cookieBannerObj = JSON.parse(cookieBanner);
            const { PP, ToU } = privacyVersionData;
            shouldShowBanner =
                PP !== cookieBannerObj.PP || ToU !== cookieBannerObj.ToU;
        }
        setShowCookiesBanner(shouldShowBanner);
    }, [privacyVersionData]);

    return (
        <div className={styles.headerBox}>
            <div>
                <img className={styles.logo} src="/new_logo.svg" alt="ProstoPay logo" />
            </div>
            <div className={styles.mainBox}>
                {showCookiesBanner && (
                    <CookieBanner
                        handleClick={handleClick}
                        open={isPopoverOpen}
                        handleClose={handleClose}
                        onSubmitCookie={onSubmitCookie}
                    />
                )}
                {showTimer && <div className={styles.timer}>{timer}</div>}
                {showPageNumber && (
                    <div className={styles.timer}>{page}</div>
                )}
            </div>
        </div>
    );
};

export { Header };
